import { MUTATIONS } from "./names";

export default {
    [MUTATIONS.CLEAR_LOCAL_USER_STATE](state: any) {
    },
}